export let page_vars = {};

export function getPageVar(key, default_value) {
    if (page_vars.hasOwnProperty(key)) {
        return page_vars[key];
    }
    return default_value || undefined;
}

export function getPageVars() {
    return page_vars;
}

export function setPageVars(data) {
    page_vars = data;
}

export function getSiteUrl(endpoint = '') {
    return `${getPageVar('site_url')}/${endpoint.replace(/(^\/)?|(\/$)?/g, '')}`;
}

export function getAppUrl(endpoint = '') {
    return `${getPageVar('app_url')}/${endpoint.replace(/(^\/)?|(\/$)?/g, '')}`;
}